import { TimePicker } from "@mui/x-date-pickers";
import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import HorarioDia from "model/meta/producao/HorarioDia";
import HorarioDiaItem from "model/meta/producao/HorarioDiaItem";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import "react-hook-form";
import { useForm } from "react-hook-form";
import HorarioDiaService from "service/meta/producao/HorarioDiaService";

const horarioDiaService = new HorarioDiaService();

export default function HorarioDiaCadastro() {

    const { control, clearErrors, setError, setFocus, register, formState: { errors } } = useForm();

    const [horarioDia, setHorarioDia] = useState<HorarioDia>(new HorarioDia());
    const [titulo, setTitulo] = useState<string>('Horário');

    const { msgAlerta } = useToastContext();

    function validar() {

        if (!horarioDia.nome) {
            setError("nome", { type: "manual", message: "Nome é Obrigatório" }, { shouldFocus: true })
            return false;
        }

        return true;
    }

    function validarPersonalizado() {
        for (let i = 0; i < horarioDia.itens.length; i++) {
            if (!horarioDia.itens[i].horaInicio || !horarioDia.itens[i].horaFim) {
                msgAlerta("Horário não informado", `Horários não foram informados corretamente no item ${i + 1}`);
                return false;
            }
            if (horarioDia.itens[i].horaInicio >= horarioDia.itens[i].horaFim) {
                msgAlerta("itens", "Hora início deve ser menor que hora fim");
                return false;
            }
            for (let j = 0; j < horarioDia.itens.length; j++) {
                if (i == j) {
                    continue;
                }
                if (horarioDia.itens[i].horaInicio >= horarioDia.itens[j].horaInicio && horarioDia.itens[i].horaInicio <= horarioDia.itens[j].horaFim) {
                    msgAlerta("Horários não podem se sobrepor", `Horários dos itens ${j + 1} e ${i + 1} se sobrepõem`);
                    return false;
                }
            }
        }
        return true;
    }

    function timePicker(rowData: HorarioDiaItem, field: string) {

        return <TimePicker
            value={dayjs().hour(0).minute(rowData[field as keyof HorarioDiaItem] as number)}
            className="time-picker-horario"
            timeSteps={{ minutes: 1 }}
            onChange={(newValue) => {
                (rowData[field as keyof HorarioDiaItem] as number) = newValue ? ((newValue.hour() * 60) + newValue.minute()) : 0;
                setHorarioDia({ ...horarioDia });
            }}
        />;
    }

    return (

        <BaseCadastro model={horarioDia} service={horarioDiaService} setModel={(value: HorarioDia) => setHorarioDia(value)}
            validar={() => validar()} validarPersonalizado={() => validarPersonalizado()}
            urlService="/horarioDia" pathCadastro="/horarioDia" tituloPagina={titulo}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText
                        className={errors.nome ? "p-invalid" : ""}
                        required value={horarioDia.nome}
                        style={{ width: '30%' }}
                        {...register("nome", {
                            onChange: (e) => {
                                setHorarioDia({ ...horarioDia, nome: e.target.value })
                                clearErrors("nome")
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row" style={{ marginTop: 8 }}>
                <div className="col-sm-6" style={{ padding: 0, marginTop: 8 }}>
                    <BaseDataTableEdit
                        tituloLista="Horários"
                        getNewModel={() => new HorarioDiaItem()}
                        dataKey="key"
                        lista={horarioDia.itens ? horarioDia.itens : []}
                        setLista={(value: any) => setHorarioDia({ ...horarioDia, itens: value })}
                        scrollable
                        scrollHeight='500px'
                        showEdit={false}

                    >
                        <Column field="" header="Hora início" style={{ width: '45%' }} body={(rowData) => timePicker(rowData, 'horaInicio')} />
                        <Column field="" header="Hora fim" style={{ width: '45%' }} body={(rowData) => timePicker(rowData, 'horaFim')} />
                    </BaseDataTableEdit>
                </div>
            </div>

        </BaseCadastro>
    )
}
